module.exports = __webpack_public_path__ + "img/caret-square-down-solid.b70f0d1e.svg";